<template>
    <v-container fluid id="embedded-viewer" class="px-0 px-sm-3">
            <v-row
              no-gutters
              align="center"
              justify="center"
              class="fill-height"
            >
            <div
                  class="container-configurator pb-0"
                  :style="colHeightViewer"
                >
                <div style="position: relative; margin: auto; height: 100%" :style="$vuetify.display.smAndDown ? 'width: 90vw;' : 'width: 50vw;'">
                    <inspi-viewer :change-color="changeColor" @arClick="$emit('arClick')" />
                    <viewer-pad 
                      v-if="isProductLoaded"
                      @resetClick="$emit('resetClick')"
                      @dimensionsClick="$emit('dimensionsClick')"
                      @screenshotClick="$emit('screenshotClick')"
                    />

                </div>
                </div>
                <div v-if="$vuetify.display.mdAndUp && isProductLoaded">
                  <div
                  class="container-menu scroll pt-0 pl-9 d-flex flex-column"
                  style='position: absolute; top: 90px; left: 0'
                  :style="[colHeightMenus, colAlignMenus, maxWidthMenus]"
                >
                  <list-options :options="models" :type="model" @modelLoaded="$emit('modelLoaded', $event)" />
                </div>
                <div
                  v-if="isProductLoaded" 
                    class="container-menu scroll pt-0 pr-9 d-flex flex-column"
                    style="position: absolute; top: 90px; right: 0"
                    :style="[colHeightMenus, colAlignMenus, maxWidthMenus]"
                >
                  <list-options :options="shades" :type="shade" @modelLoaded="$emit('modelLoaded', $event)"/>
                </div>
                </div>
                
                <div
                  v-if="$vuetify.display.smAndDown && isProductLoaded"
                  class="scroll mb-2 d-flex flex-column"
                  :style="$vuetify.display.xs ? '' : 'padding-left: 6px;'"
                  style="width: 100vw;max-height: 25vh;"
                >
                <list-options :options="models" :type="model" @modelLoaded="$emit('modelLoaded', $event)" />
                <list-options :options="shades" :type="shade" @modelLoaded="$emit('modelLoaded', $event)"/>
              </div>
              <ar-button v-if="$vuetify.display.mdAndUp && isProductLoaded" class="mb-10" :change-color="changeColor" @arClick="$emit('arClick')"/>
            </v-row>
    </v-container> 
</template>
<script>
    import ListOptions from './options/ListOptions.vue'
    import InspiViewer from './viewer/InspiViewer.vue'
    import ViewerPad from './gamepad/ViewerPad.vue'
    import ArButton from './gamepad/ArButton.vue'
    import { mapGetters } from 'vuex'
  export default {
    name: 'ViewerMenusContainer',
    components: {
        ListOptions,
        InspiViewer,
        ViewerPad,
        ArButton,
    },

    data () {
      return {
        models: [],
        shades: [],
        model: 'model',
        shade: 'shade'
      }
    },

    props: {
      options: Array,
      changeColor: Boolean,
    },

    emits: ['modelLoaded', 'arClick', 'resetClick', 'dimensionsClick', 'screenshotClick'],

    watch: {
      options: function(newOptions){
        let models = []
        let shades = []
        newOptions.map(option => {
          if(option.type === 'model') models.push(option)
          if(option.type === 'color') shades.push(option)
        })
        this.models = models
        this.shades = shades
      }
      
    },

    mounted () {
      if(this.options) {
        this.options.map(option => {
          if(option.type === 'model') this.models.push(option)
          if(option.type === 'color') this.shades.push(option)
        })}
    },


    computed: {
      ...mapGetters(['isProductLoaded']),
      colHeightMenus () {
        if(this.$vuetify.display.smAndDown) return 'height: unset'
        return 'height: 70vh'
      },
      colHeightViewer () {
        if(this.$vuetify.display.smAndDown) return 'height: 50vh'
        return 'height: 80vh'
      },
      colAlignMenus () {
        if(this.$vuetify.display.smAndDown) return 'align-items: start;'
        return 'align-items: center;'
      },
      maxWidthMenus () {
        if(this.$vuetify.display.md) return 'max-width: 220px;'
        return 'max-width: 300px;'
      }
    }
  }
</script>
<style scoped>
.scroll {
  overflow-y: auto;
  scrollbar-color: lightgrey white;
  scrollbar-width: thin;
}
.container-menu {
  max-height: 70vh;
}
.container-menu__mobile {
  max-height: 25vh;
}
.scroll::-webkit-scrollbar{
  width: 6px;
  background-color: #fff;}
.scroll::-webkit-scrollbar-thumb{
  background-color: #f1f1f1;
}
</style>